import { isOnlyCallingCodeEntered } from '@elfsight/lib-utils';
import type { Field } from '../contexts';

export function validateRequiredFieldValue({ required, value, type }: Field) {
  if (!required) {
    return false;
  }

  if (typeof value === 'number') {
    return !value;
  }

  if (type === 'phone') {
    return !value?.length || isOnlyCallingCodeEntered(String(value));
  }

  return !value?.length;
}
